async function fetchAsFile (url, filename) {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: blob.type || 'image/jpeg' });
}

function isIOS () {
  return /iPad|iPhone|iPod/.test(navigator.userAgent)
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function downloadFile (file) {
  const windowURL = window.URL || window.webkitURL;
  const blobUrl = windowURL.createObjectURL(file);
  const a = document.createElement('a');
  a.style.display = 'none';
  a.href = blobUrl;
  a.download = file.name;
  document.body.appendChild(a);
  a.click();
  windowURL.revokeObjectURL(blobUrl);
  a.remove();
}

function downloadFiles (files) {
  files.forEach((file) => downloadFile(file));
}

export { fetchAsFile, downloadFile, downloadFiles, isIOS };
